import axios from 'axios';

const backend_host = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:31288';



const backendService = axios.create({
    baseURL: backend_host,
    headers: {
        "Content-Type": "application/json",
        'Access-Control-Allow-Origin': '*',
    }
})

backendService.interceptors.response.use(
    (response) => {
        const path = window.location.pathname;  
        if (response.data.isLogged === false && path !== '/login') {
            console.log('redirecting to login...')
            localStorage.setItem('user', JSON.stringify(response.data));
            localStorage.setItem('reduxPersist:auth', JSON.stringify({"token":null,"isLogged":false,"error": false ,"message":response.message, "load":false}));
            localStorage.removeItem('reduxPersist:search');
            localStorage.removeItem('reduxPersist:articles');
            localStorage.removeItem('reduxPersist:admin');
            window.location = '/login'
      }
      return response
    },
    (error) => {
      const path = window.location.pathname;    
      if (!error.response) {
        localStorage.setItem('user', '{}');
        localStorage.setItem('reduxPersist:auth', JSON.stringify({"token":null,"isLogged":false,"error": true,"message": 'under_maintenance', "load":false}));
        localStorage.removeItem('reduxPersist:search');
        localStorage.removeItem('reduxPersist:articles');
        localStorage.removeItem('reduxPersist:admin');
        window.location = '/maintenance';
        let response = { data: {isLogged: false, isMaintenance: true} }
        return Promise.reject(response);
      } else if (error.response && (error.response.status === 401 || error.response.status === 403) && error.response.data.message !== "server_error_email_already_exists") {
        localStorage.setItem('user', JSON.stringify(error.response.data));
        localStorage.setItem('reduxPersist:auth', JSON.stringify({"token":null,"isLogged":false,"error": true,"message": error.response.data.message, "load":false}));
        localStorage.removeItem('reduxPersist:search');
        localStorage.removeItem('reduxPersist:articles');
        localStorage.removeItem('reduxPersist:admin');
        if (path !== '/login')
          window.location = '/login'
        return Promise.reject(error.response);
      } else 
        return Promise.reject(error);
     
    },
  );

export { backendService }